var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccountDropdown',{staticClass:"btn-primary",attrs:{"actions":_vm.actions,"activeAction":_vm.activeAction},on:{"action-selected":function($event){return _vm.$emit('action-selected', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }